export default function BusinessesIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
    >
      <path
        d="M1 12.2202H19M13.75 3.97021V2.47021C13.75 2.07239 13.592 1.69086 13.3107 1.40955C13.0294 1.12825 12.6478 0.970215 12.25 0.970215H7.75C7.35218 0.970215 6.97064 1.12825 6.68934 1.40955C6.40804 1.69086 6.25 2.07239 6.25 2.47021V3.97021M1.75 3.97021H18.25C18.6642 3.97021 19 4.306 19 4.72021V16.7202C19 17.1344 18.6642 17.4702 18.25 17.4702H1.75C1.33579 17.4702 1 17.1344 1 16.7202V4.72021C1 4.306 1.33579 3.97021 1.75 3.97021Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
